import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { authHeader } from '../../utils/headers'
import contactService from './contactService'
import config from '../../utils/config'

const url = config.testUrl

const initialState = {
	error: false,
	loading: false,
	success: false,
	message: '',
}

// post contact us form
export const postContact = createAsyncThunk(
	'contact/post',
	async (obj, thunkAPI) => {
		try {
			return await contactService.create(obj)
		} catch (error) {
			const message =
				(error.response &&
					error.response.data &&
					error.response.data.message) ||
				error.message ||
				error.toString()
			return thunkAPI.rejectWithValue(message)
		}
	}
)

// get contact us form
export const get_contact = createAsyncThunk(
	'contact/get',
	async (page, thunkAPI) => {
		try {
			const {
				authLogin: { admin },
			} = thunkAPI.getState()

			const response = await axios.get(
				`${url}/admin/contacts?pageNumber=${page}`,
				{
					headers: authHeader(admin.token),
				}
			)

			return response.data.data
		} catch (error) {
			const message =
				(error.response &&
					error.response.data &&
					error.response.data.message) ||
				error.message ||
				error.toString()
			return thunkAPI.rejectWithValue(message)
		}
	}
)

export const contactSlice = createSlice({
	name: 'postContact',
	initialState,
	reducers: {
		reset: (state) => {
			state.loading = false
			state.success = false
			state.error = false
			state.message = ''
			state.contacts = null
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(postContact.pending, (state) => {
				state.loading = true
			})
			.addCase(postContact.fulfilled, (state, action) => {
				state.loading = false
				state.success = true
			})
			.addCase(postContact.rejected, (state, action) => {
				state.loading = false
				state.error = true
				state.message = action.payload
			})
			.addCase(get_contact.pending, (state) => {
				state.loading = true
			})
			.addCase(get_contact.fulfilled, (state, action) => {
				state.loading = false
				state.contacts = action.payload
			})
			.addCase(get_contact.rejected, (state, action) => {
				state.loading = false
				state.error = true
				state.message = action.payload
				state.contacts = null
			})
	},
})

export const { reset } = contactSlice.actions
export default contactSlice.reducer
